import React, { Component } from "react";

class Shipping extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div>
        <h2>shipping</h2>
      </div>
    );
  }
}

export default Shipping;
